<template>
	<div class="refundhistory">
		<publicHeader :pageTitle="pageTitle" isWhite="true"></publicHeader>
		<!-- 占位 -->
		<div class="zhanwei"></div>
		<div class="refundList" v-if="refundList && refundList != '' && refundList != []">
			<div class="refundItem" v-for="(item,index) in refundList" :key="index" @click="gotoRefundInfo(item,index)">
				<div class="refundType flex">
					<div class="refundName" :class="{'refused':item.status == 3}">{{item.vipName}}会员</div>
					<div class="refundNameVal appling" v-if="item.status == 1">申请中</div>
					<div class="refundNameVal succing" v-if="item.status == 2">退款成功</div>
					<div class="refundNameVal Refusing" v-if="item.status == 3">已拒绝</div>
				</div>
				<div class="applyForTime flex">
					<div class="typeItem">申请时间</div>
					<div class="typeVal" :class="{'refused':item.status == 3}">{{item.createTime}}</div>
				</div>
				<div class="delineTime flex">
					<div class="typeItem">到期时间</div>
					<div class="typeVal" :class="{'refused':item.status == 3}">{{item.expireDate}}</div>
				</div>
				<div class="remainTime flex">
					<div class="typeItem">剩余时长（天）</div>
					<div class="typeVal" :class="{'refused':item.status == 3}" v-if="item.remainingTime <= 0 || item.remainingTime == ''">0</div>
					<div class="typeVal" :class="{'refused':item.status == 3}" v-else>{{item.remainingTime}}</div>
				</div>
				<div class="forecastLines flex">
					<!-- <div class="typeItem">退款金额（元）</div> -->
					<div class="typeItem">退款预估金额（元）</div>
					<!-- <div class="typeItem" v-else>退款金额（元）</div> -->
					<div class="forecastPrice" :class="{'refused':item.status == 3}"><span class="icon_price" :class="{'refused':item.status == 3}">¥</span>{{item.expectAmount}}</div>
				</div>
			</div>
		</div>
		<div class="isEmpty" v-else>
			<img src="https://images.zhibo.tv/2022/0328/isEmpty.png" >
		</div>
	</div>
</template>

<script>
	import publicHeader from '../components/PublicHeader'

	export default {
		name: 'refundhistory',
		components: {
			publicHeader
		},
		data() {
			return {
				token:'',
				vipId:'',
				refundList: [],
				pageTitle:''
			}
		},
		created() {
			this.pageTitle = '退费记录'
			this.getToken()
			this.getRefundHistory()
		},
		methods: {
			// 获取退款记录
			getRefundHistory(){
				let params = {
					token:this.token,
					vipId:this.vipId
				}
				this.$vipapi.refundHistory(params).then(res=>{
					console.log('退款记录',res)
					if(res.data.data){
						this.refundList = res.data.data
					}
				})
			},
			gotoRefundInfo(ite,ind){
				console.log(ite,ind)
				this.$router.push(`/viprefundinfo?token=${this.token}&id=${ite.id}&vipId=${this.vipId}`)
			},
			// 获取url上的信息
			getcommit(name) {
				return (
					decodeURIComponent(
						(new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(
							location.href
						) || ['', ''])[1].replace(/\+/g, '%20')
					) || false
				)
			},
			// 获取token
			getToken() {
				if (this.$CONFIG.isVerify && this.isIOS) {
					this.token = '2a9cc326033c71cd67ac7caba01c2cd0*8028670'
				} else {
					this.token = this.getcommit('token') || ''
				}
				this.vipId = this.getcommit('vipId') || ''
				console.log(this.token)
			},
		}
	}
</script>

<style lang="less" scoped="scoped">
	.refundList {
		padding: 0 .2rem;

		.refundItem {
			background: #F9FAFC;
			border-radius: .1rem;
			margin: .2rem 0;
			padding: .4rem;
			
			.applyForTime{
				margin-top: .4rem!important;
			}
			
			.refundType{
				margin: 0!important;
			}
			
			.forecastLines{
				margin-bottom: 0!important;
			}

			.flex {
				display: flex;
				align-items: center;
				justify-content: space-between;
				line-height: .4rem;
				margin: .2rem 0;

				.refundName {
					font-size: .28rem;
					font-family: PingFangSC-Regular, PingFang SC;
					font-weight: 400;
					color: #222222;
				}

				.refundNameVal {
					font-size: .28rem;
					font-family: PingFangSC-Medium, PingFang SC;
					font-weight: 500;
				}
				.appling{
					color: #C4A485;
				}
				
				.succing{
					color: #C4A485;
					background: linear-gradient(135deg, #FF6777 0%, #FB7D54 47%, #EE4F46 100%);
					-webkit-background-clip: text;
					-webkit-text-fill-color: transparent;
				}
				
				.Refusing{
					color: #999999;
				}
				

				.typeItem {
					font-size: .28rem;
					font-family: PingFangSC-Regular, PingFang SC;
					font-weight: 400;
					color: #999999;
				}
				
				.typeVal{
					font-size: .28rem;
					font-family: PingFangSC-Regular, PingFang SC;
					font-weight: 400;
					color: #222222;
				}
				
				.forecastPrice{
					font-size: .4rem;
					font-family: BebasNeue;
					color: #222222;
					
					.icon_price{
						font-size: .3rem;
						font-family: BebasNeue;
						color: #222222;
						margin-right: .04rem;
					}
				}
				
				.refused{
					color: #999999!important;
				}
			}
		}
	}
	
	.isEmpty{
		img{
			height: 7.4rem;
			display: block;
		}
	}
</style>
